export const SET_SEARCH_PARAMS = "logActions::setSearchParams";
export const SET_OPENED_RECIPIENTS = "logActions::setOpenedRecipients";

export const setSearchParams = params => {
  return {
    type: SET_SEARCH_PARAMS,
    payload: {
      searchParams: params
    }
  };
};

export const setOpenedRecipients = openedRecipients => {
  return {
    type: SET_OPENED_RECIPIENTS,
    payload: {
      openedRecipients
    }
  };
};
